import { Download } from 'lucide-react';

export const SpeechPlayer = ({ speech, testId }) => {
  if (!speech.result) return null;
  return (
    <div className="speech-player" data-testid={`${testId}-player`}>
      <audio key={speech.result.audio_url} ref={speech.audioRef} controls preload="metadata"
        aria-label="AI-generated speech" data-testid={`${testId}-audio`}
        src={speech.result.audio_url}
        onPlay={(event) => {
          window.dispatchEvent(new CustomEvent('managed-speech-play', { detail: event.currentTarget }));
          speech.setError(''); speech.setStatus('playing');
        }}
        onPause={() => speech.setStatus('paused')} onEnded={() => speech.setStatus('ready')}
        onError={() => { speech.setStatus('idle'); speech.setError('Recording unavailable. Please generate it again.'); }} />
      <a data-testid={`${testId}-download`} href={`${speech.result.audio_url}?download=true`}
        download={`nextxus-${speech.result.voice}.mp3`} aria-label="Download MP3" title="Download MP3">
        <Download size={18} /> <span>MP3</span>
      </a>
    </div>
  );
};